import { render } from "./EnglishView.vue?vue&type=template&id=28476a03&scoped=true&ts=true"
import script from "./EnglishView.vue?vue&type=script&lang=ts"
export * from "./EnglishView.vue?vue&type=script&lang=ts"

import "./EnglishView.vue?vue&type=style&index=0&id=28476a03&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28476a03"]])

export default __exports__